import React, { useState } from "react";
import { X, ArrowRight, CheckCircle2 } from "lucide-react";

const RED = "#c00000";
const O = { fontFamily: "Outfit, sans-serif" };

export default function DemoDialog({ open, onClose, dark }) {
  const [sent, setSent] = useState(false);
  if (!open) return null;

  const surface = dark ? "#141518" : "#ffffff";
  const border = dark ? "rgba(255,255,255,0.1)" : "#e5e7eb";
  const text = dark ? "text-white" : "text-gray-900";
  const muted = dark ? "text-gray-400" : "text-gray-600";
  const field = `w-full rounded-lg border px-3 py-2.5 text-sm outline-none transition-colors focus:border-[#c00000] ${dark ? "bg-white/5 border-white/10 text-white placeholder-gray-500" : "bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-400"}`;

  const close = () => { setSent(false); onClose(); };
  const submit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="demo-dialog">
      <div className="absolute inset-0 bg-black/60" onClick={close} />
      <div className="relative rounded-2xl shadow-2xl max-w-lg w-full p-6 sm:p-7 border" style={{ background: surface, borderColor: border }}>
        <button onClick={close} aria-label="Schließen" data-testid="demo-close" className={`absolute top-4 right-4 ${muted} hover:opacity-70 transition-opacity`}><X className="w-5 h-5" /></button>
        <span className="inline-block text-[10px] font-bold tracking-[0.15em] rounded-full px-2.5 py-1 mb-3" style={{ background: `${RED}14`, color: RED }}>DESIGN-PROTOTYP · DEMO</span>

        {!sent ? (
          <>
            <h3 className={`text-xl font-bold ${text}`} style={O}>Demo anfragen</h3>
            <p className={`text-sm ${muted} mt-1 mb-4`}>Nur eine Vorschau – es werden keine Daten gesendet und keine echte Anfrage ausgelöst.</p>
            <form onSubmit={submit} className="space-y-3">
              <div className="grid sm:grid-cols-2 gap-3">
                <input data-testid="demo-name" required placeholder="Name" className={field} />
                <input data-testid="demo-company" placeholder="Unternehmen" className={field} />
              </div>
              <input data-testid="demo-email" type="email" required placeholder="E-Mail" className={field} />
              <textarea data-testid="demo-message" rows="3" placeholder="Ihre Nachricht (optional)" className={field} />
              <button data-testid="demo-submit" type="submit" className="w-full inline-flex items-center justify-center gap-2 text-white font-bold rounded-xl px-4 py-3 text-sm hover:brightness-110 transition-all" style={{ background: RED }}>
                Anfrage senden (Demo) <ArrowRight className="w-4 h-4" />
              </button>
              <p className={`text-[11px] ${muted} text-center`}>Formular ohne Funktion · reiner Design-Prototyp</p>
            </form>
          </>
        ) : (
          <div className="text-center py-6" data-testid="demo-success">
            <span className="inline-flex w-14 h-14 rounded-full items-center justify-center mb-3" style={{ background: `${RED}14` }}><CheckCircle2 className="w-7 h-7" style={{ color: RED }} /></span>
            <h3 className={`text-xl font-bold ${text}`} style={O}>Demo-Bestätigung</h3>
            <p className={`text-sm ${muted} mt-1 max-w-sm mx-auto`}>Dies ist ein Prototyp – es wurde nichts gesendet. In der echten Plattform würde hier Ihre Anfrage eingehen.</p>
            <button data-testid="demo-success-close" onClick={close} className="mt-5 text-white font-semibold rounded-xl px-5 py-2.5 text-sm hover:brightness-110 transition-all" style={{ background: RED }}>Schließen</button>
          </div>
        )}
      </div>
    </div>
  );
}
